(() => {
  const batchSize = 60;

  class AddaxBalancedLoadMore {
    constructor(grid) {
      this.grid = grid;
      this.buffer = [];
      this.nextUrl = this.readNextUrl(document);
      this.visitedUrls = new Set();
      this.loading = false;
      this.abortController = new AbortController();
      this.button = null;
      this.priceSortDirection =
  this.getPriceSortDirection();

      this.onButtonClick =
        this.onButtonClick.bind(this);
    }

    getCards(grid = this.grid) {
  return Array.from(grid.children).filter(
    (element) =>
      element.matches('li.grid__item')
  );
}
getPriceSortDirection() {
  const urlSortBy = new URL(
    window.location.href
  ).searchParams.get('sort_by');

  const selectedSortInput =
    document.querySelector(
      '#FacetFiltersForm input[name="sort_by"]:checked, ' +
      '#FacetFiltersFormMobile input[name="sort_by"]:checked'
    );

  const selectedSortBy =
    selectedSortInput?.value ||
    selectedSortInput?.dataset.value ||
    selectedSortInput?.getAttribute('data-value') ||
    '';

  const sortBy =
    urlSortBy || selectedSortBy;

  if (sortBy === 'price-ascending') {
    return 1;
  }

  if (sortBy === 'price-descending') {
    return -1;
  }

  return 0;
}

getCardDisplayPrice(card) {
  const rawPrice =
    card.dataset.plpDisplayPrice;

  if (!rawPrice) return null;

  const price = Number(rawPrice);

  return Number.isFinite(price)
    ? price
    : null;
}

sortCardsByDisplayPrice(cards) {
  if (!this.priceSortDirection) {
    return cards;
  }

  return cards
    .map((card, index) => ({
      card,
      index,
      price: this.getCardDisplayPrice(card),
    }))
    .sort((firstCard, secondCard) => {
      if (
        firstCard.price === null &&
        secondCard.price === null
      ) {
        return firstCard.index - secondCard.index;
      }

      if (firstCard.price === null) return 1;
      if (secondCard.price === null) return -1;

      if (firstCard.price === secondCard.price) {
        return firstCard.index - secondCard.index;
      }

      return (
        (firstCard.price - secondCard.price) *
        this.priceSortDirection
      );
    })
    .map(({ card }) => card);
}
async preparePriceSortedBatches() {
  const allCards = this.getCards();

  while (this.nextUrl) {
    await this.fetchNextPage();
  }

  allCards.push(...this.buffer);
  this.buffer = [];

  const sortedCards =
    this.sortCardsByDisplayPrice(allCards);

  const visibleCards =
    sortedCards.slice(0, batchSize);

  this.buffer =
    sortedCards.slice(batchSize);

  this.grid.replaceChildren(
    ...visibleCards
  );

  if (
    typeof window.applyMobileGridView ===
    'function'
  ) {
    window.applyMobileGridView();
  }

  document.dispatchEvent(
    new CustomEvent(
      'addax:product-cards-added',
      {
        detail: {
          count: visibleCards.length,
        },
      }
    )
  );
}
updateVisibleCount() {
  if (
    this.nextUrl ||
    this.buffer.length > 0
  ) {
    return;
  }

  const cardCount =
    this.getCards().length;

  const label =
    `${cardCount} ${
      cardCount === 1
        ? 'Product'
        : 'Products'
    }`;

  document
    .querySelectorAll('.counter-of-p')
    .forEach((counter) => {
      counter.textContent = label;
      counter.style.visibility = 'visible';
    });

  document
    .querySelectorAll(
      '.mobile-see-products-btn'
    )
    .forEach((button) => {
      button.textContent =
        `SEE PRODUCTS (${cardCount})`;
    });
}
    readResultCount(root) {
  const countElement = root.querySelector(
    '#ProductCount, #ProductCountDesktop'
  );

  const countMatch =
    countElement?.textContent?.match(/\d[\d,]*/);

  if (!countMatch) return null;

  const count = Number(
    countMatch[0].replace(/,/g, '')
  );

  return Number.isFinite(count)
    ? count
    : null;
}

inferNextUrl(
  root,
  baseUrl = window.location.href
) {
  const resultCount =
    this.readResultCount(root);

  if (!resultCount) return null;

  const currentUrl = new URL(
    baseUrl,
    window.location.href
  );

  const currentPage = Number(
    currentUrl.searchParams.get('page') || 1
  );

  if (
    !Number.isFinite(currentPage) ||
    resultCount <= currentPage * batchSize
  ) {
    return null;
  }

  currentUrl.searchParams.set(
    'page',
    String(currentPage + 1)
  );

  return currentUrl.href;
}

readNextUrl(
  root,
  baseUrl = window.location.href
) {
  const nextLink = root.querySelector(
    '.infinite_next a'
  );

  const href = nextLink?.getAttribute('href');

  if (href) {
    return new URL(href, baseUrl).href;
  }

  return this.inferNextUrl(root, baseUrl);
}

    getPaginationWrapper() {
      return (
        this.grid
          .closest('.collection')
          ?.querySelector('.pagination-wrapper') ||
        document.querySelector(
          '.s-collection .pagination-wrapper'
        )
      );
    }

    createPaginationWrapper() {
      const wrapper = document.createElement('div');

      wrapper.className = 'pagination-wrapper';

      wrapper.innerHTML = `
        <nav
          class="pagination"
          role="navigation"
          aria-label="Pagination"
        >
          <ul
            class="pagination__list list-unstyled"
            role="list"
          >
            <li class="infinite_next">
              <a
                href="#"
                class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
                aria-label="Load more products"
              >
                <span>LOAD MORE</span>
              </a>
            </li>
          </ul>
        </nav>
      `;

      this.grid.parentElement?.appendChild(wrapper);

      return wrapper;
    }

    prepareFirstBatch() {
      const cards = this.getCards();

      if (cards.length <= batchSize) return;

      cards
        .slice(batchSize)
        .forEach((card) => {
          card.remove();
          this.buffer.push(card);
        });
    }

    async fetchNextPage() {
      if (
        !this.nextUrl ||
        this.visitedUrls.has(this.nextUrl)
      ) {
        this.nextUrl = null;
        return;
      }

      const requestUrl = this.nextUrl;

      this.visitedUrls.add(requestUrl);

      const response = await fetch(requestUrl, {
        credentials: 'same-origin',
        signal: this.abortController.signal,
      });

      if (!response.ok) {
        throw new Error(
          `Load More request failed: ${response.status}`
        );
      }

      const responseText = await response.text();

      const parsedPage =
        new DOMParser().parseFromString(
          responseText,
          'text/html'
        );

      const fetchedGrid =
        parsedPage.getElementById('product-grid');

      const fetchedCards = fetchedGrid
        ? Array.from(
            fetchedGrid.children
          ).filter((element) =>
            element.matches('li.grid__item')
          )
        : [];

      fetchedCards.forEach((card) => {
        card
          .querySelectorAll(
            'script:not([type="application/json"])'
          )
          .forEach((script) => script.remove());

        this.buffer.push(
          document.importNode(card, true)
        );
      });

      this.nextUrl =
  this.readNextUrl(parsedPage, requestUrl);
    }

    async appendCards(requiredCount) {
      let appendedCount = 0;
      const fragment =
        document.createDocumentFragment();

      while (appendedCount < requiredCount) {
        if (this.buffer.length === 0) {
          if (!this.nextUrl) break;

          await this.fetchNextPage();

          if (
            this.buffer.length === 0 &&
            !this.nextUrl
          ) {
            break;
          }
        }

        const card = this.buffer.shift();

        if (!card) break;

        fragment.appendChild(card);
        appendedCount += 1;
      }

      if (appendedCount > 0) {
        this.grid.appendChild(fragment);

        if (
          typeof window.applyMobileGridView ===
          'function'
        ) {
          window.applyMobileGridView();
        }

        document.dispatchEvent(
          new CustomEvent(
            'addax:product-cards-added',
            {
              detail: {
                count: appendedCount,
              },
            }
          )
        );
      }

      return appendedCount;
    }

    ensurePaginationButton() {
      const hasMoreProducts =
        this.buffer.length > 0 ||
        Boolean(this.nextUrl);

      let wrapper =
        this.getPaginationWrapper();

      if (!hasMoreProducts) {
        wrapper?.remove();
        this.button = null;
        return;
      }

      if (!wrapper) {
        wrapper =
          this.createPaginationWrapper();
      }

      const newButton = wrapper.querySelector(
        '.infinite_next a'
      );

      if (!newButton) return;

      if (this.button !== newButton) {
        this.button?.removeEventListener(
          'click',
          this.onButtonClick
        );

        this.button = newButton;

        this.button.addEventListener(
          'click',
          this.onButtonClick
        );
      }

      this.button.href =
        this.nextUrl || '#';
    }

    setLoading(isLoading) {
      this.loading = isLoading;

      if (!this.button) return;

      const label =
        this.button.querySelector('span');

      if (label) {
        label.textContent = isLoading
          ? 'LOADING...'
          : 'LOAD MORE';
      }

      this.button.setAttribute(
        'aria-busy',
        String(isLoading)
      );

      this.button.style.pointerEvents =
        isLoading ? 'none' : '';
    }

    async fillFirstBatch() {
      const currentCount =
        this.getCards().length;

      const missingCount =
        Math.max(0, batchSize - currentCount);

      if (missingCount === 0) return;

      this.setLoading(true);

      try {
        await this.appendCards(missingCount);
      } finally {
        this.setLoading(false);
      }
    }

    async onButtonClick(event) {
      event.preventDefault();

      if (this.loading) return;

      this.setLoading(true);

      try {
        await this.appendCards(batchSize);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error(error);
        }
      } finally {
  this.setLoading(false);
  this.ensurePaginationButton();
  this.updateVisibleCount();
}
    }

   async initialise() {
  this.ensurePaginationButton();

  if (this.priceSortDirection) {
    this.setLoading(true);

    try {
      await this.preparePriceSortedBatches();
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error(error);
      }
    } finally {
  this.setLoading(false);

  this.grid
    .closest('.product-grid-container')
    ?.classList.remove(
      'plp-price-sort-loading'
    );
}
  } else {
    this.prepareFirstBatch();

    try {
      await this.fillFirstBatch();
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error(error);
      }
    }
  }

  this.ensurePaginationButton();
  this.updateVisibleCount();
}

    destroy() {
      this.abortController.abort();

      this.button?.removeEventListener(
        'click',
        this.onButtonClick
      );
    }
  }

  window.initAddaxBalancedLoadMore = () => {
    window.addaxBalancedLoadMore?.destroy();

    window.addaxBalancedLoadMore = null;

    const grid = document.querySelector(
      '.s-collection #product-grid'
    );

    if (!grid) return false;

    const loader =
      new AddaxBalancedLoadMore(grid);

    window.addaxBalancedLoadMore = loader;

    loader.initialise();

    return true;
  };
})();